import { CallableInput } from "Components/Shared";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React, { Fragment } from "react";
import { Button, Form, Message } from "semantic-ui-react";

const ClientCredentials = () => {
  const {
    device,
    update,
    validateClientUsername,
    validatePassword,
  } = useDevice();

  if (!device) return <Fragment />;

  return (
    <Formik
      initialValues={device}
      //   validationSchema={DeviceSchema}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {(props: any) => (
        <Form onSubmit={props.handleSubmit}>
          <Field
            name='client.username'
            label='Username'
            validate={validateClientUsername}
            component={CallableInput}
          />

          <Field
            name='client.password'
            label='Password'
            type='password'
            validate={validatePassword}
            component={CallableInput}
          />

          {!isEmpty(props.errors?.client?.password) && (
            <Message size='mini' info>
              Password Requires <br />
              1. At least 12 Characters <br />
              2. 1 Digit <br />
              3. 1 Uppercase <br />
              4. 1 Lowercase <br />
              5. 1 Special Character
            </Message>
          )}

          {console.log(props.errors)}
          <Button primary type='submit' disabled={!isEmpty(props.errors)}>
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default ClientCredentials;
